import { UIComponentState, UIComponentProps, UIComponentImpl, UIDataModel, UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { ErrorViewImpl } from './errortview';
import { ErrorCSSStyleImpl } from './errorcss';

export interface ErrorComponentProps extends UIComponentProps
{

}


export class ErrorComponent extends UIComponentImpl<ErrorComponentProps, UIComponentState, UIDataModel>
{
    constructor(props: ErrorComponentProps)
    {
        super(props);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ErrorViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ErrorCSSStyleImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/navigation/error/errorcomponent.tsx